import React from "react";

// A page component loaded on first use (audit OPS-14). After a deploy, the
// page chunks this tab was built with no longer exist; the first failed load
// reloads the app once to pick up the new build, instead of leaving a blank
// page. A second failure within a minute is shown by the error boundary.
const RELOAD_KEY = "housify:chunk-reload-at";

export function lazyPage(loader, name) {
  return React.lazy(() => loader().then(
    (m) => ({ default: name === "default" ? m.default : m[name] }),
    (err) => {
      const isChunk = /Loading (CSS )?chunk|ChunkLoadError|dynamically imported module/i.test(String(err && (err.name + " " + err.message)));
      let last = 0;
      try { last = Number(sessionStorage.getItem(RELOAD_KEY)) || 0; } catch (_) { /* storage blocked */ }
      if (isChunk && Date.now() - last > 60000) {
        try { sessionStorage.setItem(RELOAD_KEY, String(Date.now())); } catch (_) { /* storage blocked */ }
        window.location.reload();
        return new Promise(() => {}); // the reload replaces the page
      }
      throw err;
    }
  ));
}
